export default {
    USER_BLACKLIST: 'userBlackList',
    USER_WHITELIST: 'userWhiteList',
    USER_THEME: 'userTheme',
    DOMAINS: 'domains',
    SPAM_NOTIFICATION: 'spamNotification',
    ORG_WHITELIST: 'orgWhitelist',
    ORG_BLACKLIST: 'orgBlacklist',
    TIMEZONE: 'timezone',
    TIMEZONES: 'timezones',
    MAILBOX_SETTINGS: 'mailboxSettings',
    AVAILABILITY_ALERT_HOURLY: 'availabilityAlertHourly',
    AVAILABILITY_ALERT_DAILY: 'availabilityAlertDaily',
    VIRUS_INCOMING_SETTINGS: 'virusIncomingSettings',
    VIRUS_OUTGOING_SETTINGS: 'virusOutgoingSettings',
    BUSINESS_CONTINUITY_CONTINUE_MODE: 'businessContinuityContinueMode',
    BUSINESS_CONTINUITY_TEMPORARY_BOUNCE_POLICY: 'businessContinuityTemporaryBouncePolicy',
    BUSINESS_CONTINUITY_PERMANENT_BOUNCE_POLICY: 'businessContinuityPermanentBouncePolicy',
    OUTGOING_IP_OR_DOMAINS_ADDRESS: 'outgoingIpOrDomainAddress',
    INCOMING_IP_OR_DOMAIN_ADDRESS: 'incomingIpOrDomainAddress',
    AVAILABILITY_ALERT_HOURLY_SUBSCRIBER: 'availabilityAlertHourlySubscriber',
    AVAILABILITY_ALERT_DAILY_SUBSCRIBER: 'availabilityAlertDailySubscriber',
    EMAIL_FOOTER: 'emailFooter',
    DOMAIN_BLACKLIST_SETTINGS: 'domainBlackListSettings',
    DOMAIN_WHITELIST_SETTINGS: 'domainWhiteListSettings',
    SINGLE_SIGN_ON_STATUS: 'singleSignOnStatus',
    SINGLE_SIGN_ON_DETAILS: 'singleSignOnDetails',
    ARCHIVE_TOOL_BOX_SOURCES: 'archiveToolBoxSources',
    ARCHIVE_TOOL_BOX_SOURCES_ORG: 'archiveToolBoxSourcesOrganisation',
    ARCHIVE_TOOL_BOX_SUBSCRIPTIONS: 'archiveToolBoxSubscriptions',
    DISCOVERY_TOOL_MINIMUM_APPROVER: 'discoveryToolMinimumApprover',
    ARCHIVE_TOOL_BOX_PROCESS_URLS: 'archiveToolBoxProcessURLs',
    SINGLE_SIGN_ON: 'o365_sso'
};